import angular from 'angular';
import { routes } from "./topicos.routes";
import DirectoryTopicosController from "./directory/directory.controller";
export default angular.module('app.elv.topicos', [])
    .config(routes)
    .controller('DirectoryTopicosController', DirectoryTopicosController)
    .name;
